import { useCanUserDoOnProject } from "../../../canUserDo";

export function useUserCanEdit(projectId: string) {
  return useCanUserDoOnProject("DASHBOARD_EDIT", projectId);
}
